export default __webpack_public_path__ + "static/media/226.02b3cb7a.png";